import React from 'react';
import { inputsV2 } from '@ecosystem/newron-design-system';
import { FilterProps } from './types';

const { Select } = inputsV2;

function SelectFilter({ definition: { label, name, placeholder, options }, values, disabled, onChange }: FilterProps) {
  const handleSelectChange = (value: string) => {
    const entity = options.find(option => option.value === value);
    onChange(name, entity ? [entity] : []);
  };

  return (
    <div data-test-id={label}>
      <Select
        placeholder={placeholder ?? 'Any'}
        label={label}
        options={options}
        value={values?.[0]?.value}
        disabled={disabled}
        onChange={handleSelectChange}
        combobox
      />
    </div>
  );
}

export { SelectFilter };
